import type { SVGProps } from "react";
export interface VoucherPercentIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function VoucherPercentIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: VoucherPercentIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 7.5c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v.932a3.622 3.622 0 0 1 0 7.135v.933c0 1.035.84 1.875 1.875 1.875h14c1.035 0 1.875-.84 1.875-1.875v-.933a3.623 3.623 0 0 1 0-7.135zm2.25 2c0 .62-.504 1.124-1.125 1.124h-.5a1.376 1.376 0 0 0 0 2.752h.5c.62 0 1.125.503 1.125 1.125V16.5A4.125 4.125 0 0 1 19 20.625H5A4.125 4.125 0 0 1 .875 16.5v-2c0-.62.504-1.124 1.125-1.124h.5a1.376 1.376 0 0 0 0-2.752H2A1.125 1.125 0 0 1 .875 9.5v-2A4.125 4.125 0 0 1 5 3.375h14A4.125 4.125 0 0 1 23.125 7.5z"
      />
      <path
        fill={color}
        d="M14.705 7.705a1.125 1.125 0 0 1 1.59 1.59l-7 7a1.125 1.125 0 0 1-1.59-1.59zm-.205 6.924a.62.62 0 0 0-.124.37l.011.127c.019.09.06.172.113.244zm1 .741a.6.6 0 0 0 .112-.244l.013-.127-.013-.126a.6.6 0 0 0-.111-.244zm-7-6.741a.62.62 0 0 0-.125.37l.012.126a.6.6 0 0 0 .113.245zm1 .741a.6.6 0 0 0 .112-.245L9.625 9l-.013-.126a.6.6 0 0 0-.112-.245zM16.625 15a1.625 1.625 0 0 1-3.242.167l-.008-.168.009-.165a1.625 1.625 0 0 1 1.615-1.459l.167.009c.82.083 1.46.774 1.46 1.615Zm-6-6a1.625 1.625 0 0 1-3.242.167L7.376 9l.009-.166A1.625 1.625 0 0 1 9 7.375l.166.009c.82.083 1.46.774 1.46 1.616Z"
      />
    </svg>
  );
}
